import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography, Box } from '@mui/material';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { NavigateFunction, useNavigate } from 'react-router-dom';

// COMPONENT 👇
import * as styles from '.././styles/login.style'
import { RouteImage } from '../../../assets/routeImage';
import InputTextField from '../../../component/input/inputTextField';
import { ButtonCustom } from '../../../component/mui-custom/MuiCustom';
import { Authentication } from '../../../api/auth/Authentication.api';
import Loading from '../../../component/loading/Loading';
import { swalError } from '../../../component/notification/swal';
import { ResourcePathApi } from '../../../constants/resource.pathapi';


type forgotPasswordType = {
    email: string;
}

const ForgotPassword: React.FC = () => {
    const { t } = useTranslation();
    const navigate: NavigateFunction = useNavigate();

    const [pathUrl, setPathUrl] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [email, setEmail] = useState<forgotPasswordType>({
        email: ""
    });

    const handleChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail({ ...email, email: event?.target.value })
    }

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        setIsLoading(true)
        await Authentication.forgotPassword(email)
            .then(res => {
                if (res.status === 200) {
                    console.log(res.data)
                    setIsLoading(false);
                    const ref = res?.data?.result?.ref
                    ref && navigate('/otp-confirm', { state: { email: email.email, ref: ref } })
                } else {
                    console.log(res.data)
                }
            })
            .catch(error => {
                swalError(error.response?.data?.description || "เกิดข้อผิดพลาดในการส่งข้อมูล")
                setIsLoading(false);
            })
    }

    useEffect(() => {
        const fetchPath = async () => {
            const path = await ResourcePathApi();
            setPathUrl(path);
        }
        fetchPath();
    }, [])


    return (
        <styles.Container
            sx={{
                background: pathUrl && `url(${pathUrl.REACT_APP_BASE_API}/login-background) no-repeat`,
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
        >
            {isLoading && <Loading />}
            <styles.FormAuthentication className='w-full' onSubmit={handleSubmit}>
                <styles.MainBox>
                    <styles.LoginBox
                        style={{ minHeight: "694px" }}
                        className='border-[1px] border-light'
                        initial={{ x: 200 }}
                        animate={{ x: 0 }}
                        transition={{ type: "spring", stiffness: 100, ease: "backInOut", bounce: 0.25 }}
                    >
                        <div className='flex justify-center items-center'>
                            <img src={RouteImage.login_logo} alt='logo' />
                        </div>
                        <div className='mt-[36px]'>
                            <Typography variant='h4' component="h1">{t("ระบบสารสนเทศเพื่อการติดตามและประเมินผลโครงการ")}</Typography>
                            <Typography variant='h4' component="h1" >
                                {t(" (E-Monitoring and Evaluation)")}
                            </Typography>
                        </div>

                        <Box className="mt-9 flex justify-center items-center relative gap-x-3">
                            <span className='flex-1 h-[1px] bg-base_secondary'></span>
                            <span>
                                <Typography className='text-base_secondary' variant='h6'>
                                    {t("LOGIN.FORGOT_PASSWORD")}
                                </Typography>
                            </span>
                            <span className='flex-1 h-[1px] bg-base_secondary'></span>
                        </Box>
                        <Box className="mt-9">
                            <InputTextField
                                required
                                value={email.email}
                                onchange={handleChangeEmail}
                                heading='อีเมล'
                                type='email'
                                endAdornment={<EmailOutlinedIcon className='text-base_secondary' />}
                            />
                        </Box>
                        <Box className="mt-2">
                            <Typography className='text-base_secondary'>{"ระบบจะทำการส่งลิงก์การตั้งค่ารหัสผ่านใหม่ให้ท่าน"}</Typography>
                        </Box>
                        <Box className='w-full mt-[36px]'>
                            <ButtonCustom type='submit' variant='contained' sx={{ height: "48px" }} fullWidth>
                                {t("BUTTON.SUBMIT")}
                            </ButtonCustom>
                        </Box>
                    </styles.LoginBox>
                </styles.MainBox>
            </styles.FormAuthentication>
        </styles.Container>
    )
}

export default ForgotPassword
